<template>
    <div class="main-content d-flex justify-content-center align-items-center">
        <div class="justify-content-center">
            <h1 class="heading-text text-white mb-5">
                BECOME OUR AGENT/REALTOR
            </h1>
            <div class="col-12 d-flex justify-content-center">
                <button class="btn-lg btn-danger-custom download-btn"
                    v-if="! form_url">
                    DOWNLOAD FORM
                </button>
                <a v-if="form_url"
                :href="form_url"
                target="_blank" rel="noreferrer noopener"
                class="btn-lg btn-danger-custom download-btn">
                    DOWNLOAD FORM
                </a>
            </div>
            <span class="d-block text-white font-italic mt-4">
                Click to download form, fill and submit
            </span>
        </div>
    </div>
</template>

<script>
import bgImage from '../../assets/k0RSXoBZux.png'
export default {
    name: 'AnAgent',
    computed: {
        form_url() {
            return this.$store.state.agent_form_url || ''
        }
    },
    data() {
        return {
            bgImage
        }
    }
}
</script>

<style scoped>
.text-white {
    position:relative;
    z-index:10
}
.main-content {
    min-height: 60vh!important;
}
.download-btn,
.download-btn:hover {
    border-radius: 20px;
    padding-left: 30px; 
    padding-right: 30px;
    text-decoration: none;
    text-align: center;
    color: #fff;
}
</style>